import React from "react";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";

import OrderTableSkeleton from "../../tables/OrderLineItemsTable/OrderTableSkeleton";
import { CustomerOrdersTable } from "../../tables";
import {
  useGetCustomerOrderData,
  useGetCustomerDetailsById,
} from "../../hooks";

import CustomerOrdersBar from "./CustomerOrdersBar";
import CustomerOrdersEmpty from "./CustomerOrdersEmpty";

const name = "purchase-order-create";

export const CustomerOrders = ({ hideBar = false }) => {
  const { id } = useParams();
  const { data, isLoading } = useGetCustomerOrderData(id);
  const { data: customer } = useGetCustomerDetailsById(id);

  const hasParts = !!customer?.hasParts;
  const isVendor = !!customer?.isVendor;
  const count = data?.meta?.count;

  const createProps =
    !hasParts && !isVendor
      ? {
          disabled: true,
          hoverTitle: "Customer Has No Parts",
          hoverSubtitle: "Cannot create order for customer without parts",
        }
      : {};

  if (isLoading) return <OrderTableSkeleton />;
  return (
    <>
      {count ? (
        <Stack gap="25px" height="100%" overflow="hidden">
          {!hideBar && (
            <CustomerOrdersBar
              createProps={createProps}
              name={name}
              count={count}
            />
          )}
          <CustomerOrdersTable />
        </Stack>
      ) : (
        <CustomerOrdersEmpty createProps={createProps} />
      )}
    </>
  );
};

export default CustomerOrders;
